import { Box, Button, Dialog, Message, Pagination, Table } from '@alifd/next';
import { DatePicker, Form, Input, Select, Upload } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { BackStageContext } from '@/contexts/BackStageContext';
import client from '@/lib/feathers';
import { deleteFile, uploadFiles } from '@/lib/manipulateFile';

import RecordDescription from '../components/RecordDescription';

const Item = Form.Item;

const inputs = {
  Input,
  Select,
  TextArea: Input.TextArea,
  DatePicker,
  RangePicker: DatePicker.RangePicker,
};

function ViewButton({
  dbName = '',
  fields = [],
  func,
  defaultValue = {},
  setIsUpdate = () => {},
  setSelectedVendor = () => {},
}) {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [uploadingList, setUploadingList] = useState([]);
  //資產
  const [deviceList, setDeviceList] = useState([]);
  const [deviceDetail, setDeviceDetail] = useState({});
  const [showDeviceDetail, setShowDeviceDetail] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  //問卷
  const [questionnaireList, setQuestionnaireList] = useState([]);
  const { setBackStageUpdateTrigger } = useContext(BackStageContext);

  const formatValue = useMemo(() => {
    const newValue = { ...defaultValue };

    if (defaultValue.contractPeriod) {
      const [start, end] = defaultValue.contractPeriod;
      newValue.contractPeriod = [moment(start), moment(end)];
    }
    if (defaultValue?.companyId) {
      newValue.company = newValue.tableName + '-' + newValue.companyId;
      // setSelectedVendor(newValue.company);
    }
    ['startDate', 'transferDate'].forEach((field) => {
      if (defaultValue[field]) {
        newValue[field] = moment(defaultValue[field]);
      }
    });

    return newValue;
  }, [defaultValue]);

  useEffect(() => {
    form.setFieldsValue(formatValue);
  }, [form, formatValue]);

  const handleSubmit = useCallback(async () => {
    try {
      let values = await form.validateFields();
      values = JSON.parse(JSON.stringify(values));

      ['contractPeriod', 'period'].forEach((field) => {
        if (Object.hasOwnProperty.call(values, field)) {
          values[field] = values[field].map((time) => moment(time).valueOf());
        }
      });
      ['startDate', 'transferDate'].forEach((field) => {
        if (Object.hasOwnProperty.call(values, field)) {
          values[field] = moment(values[field]).valueOf();
        }
      });
      if (values.company) {
        const [tableName, id] = values.company.split('-');
        values.tableName = tableName;
        values.companyId = id;
        delete values.company;
      }
      if (func.deleteStatus) {
        values.activated = true;
      }

      if (defaultValue._id) {
        await client.service(dbName).patch(defaultValue._id, values);
        Message.success('修改成功');
      } else {
        await client.service(dbName).create(values);
        Message.success('新增成功');
      }
      form.resetFields();
      setBackStageUpdateTrigger({});
      setIsUpdate(true);
      setVisible(false);
      setSelectedVendor('');
    } catch (err) {
      console.error({ err });
      Message.error('上傳發生錯誤');
    }
  }, [
    dbName,
    defaultValue._id,
    form,
    func.deleteStatus,
    setBackStageUpdateTrigger,
    setIsUpdate,
    setSelectedVendor,
  ]);

  //取得所屬廠商資產設備
  useEffect(() => {
    if (visible) {
      axios(
        `/ezcon/api/coVendor/${defaultValue._id}/equipments?deviceType=nonConsumable`,
        {
          method: 'GET',
          headers: {
            authorization: window.localStorage['feathers-jwt'],
          },
        }
      )
        .then((res) => {
          console.log(res, 'coVendor');
          setDeviceList(res.data);
        })
        .catch((err) => {
          console.log(err);
          Message.error(err);
        });
      axios(
        `/ezcon/api/coVendor/${
          defaultValue._id
        }/services/questionnaires/statistics?year=${moment().year()}&month=${
          moment().month() + 1
        }`,
        {
          method: 'GET',
          headers: {
            authorization: window.localStorage['feathers-jwt'],
          },
        }
      )
        .then((res) => {
          console.log(res, 'questionnaire');
          setQuestionnaireList(res.data);
        })
        .catch((err) => {
          console.log(err);
          Message.error(err);
        });
    }
  }, [visible, defaultValue]);
  // console.log(defaultValue);
  // console.log(visible);
  return (
    <>
      <Button
        type="secondary"
        onClick={() => {
          setVisible(true);
          if (formatValue?.company) {
            setSelectedVendor(formatValue.company);
          }
        }}
      >
        {func.text}
      </Button>
      <Dialog
        {...{
          visible,
          onCancel: () => {
            if (defaultValue._id) {
              form.setFieldsValue(formatValue);
            } else {
              form.resetFields();
            }
            setVisible(false);
          },
          onClose: () => {
            if (defaultValue._id) {
              form.setFieldsValue(formatValue);
            } else {
              form.resetFields();
            }
            setVisible(false);
          },
          onOk: handleSubmit,
          okProps: {
            loading: uploadingList.length > 0,
            disabled: uploadingList.length > 0,
          },
        }}
        title={func.text}
      >
        <Form
          form={form}
          style={{
            width: '600px',
            maxHeight: '500px',
            overflowY: 'auto',
          }}
          initialValues={formatValue}
          onFieldsChange={(changedFields) => {
            if (changedFields[0].name.includes('company')) {
              form.setFieldsValue({
                ...form.getFieldsValue(),
                service: [],
              });
            }
          }}
        >
          {Object.values(fields)
            .filter((field) => field.input.type !== 'hidden')
            .map((field, index) => {
              let fieldComponent = <></>;
              if (field.input.type === 'Upload') {
                fieldComponent = (
                  <Item
                    {...field.item.props}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      const { file, fileList } = e;
                      if (file.status === 'uploading') {
                        setUploadingList((prev) => [
                          ...prev,
                          {
                            uid: file.uid,
                            name: file.name,
                          },
                        ]);
                      } else {
                        setUploadingList((prev) =>
                          prev.filter((item) => item.uid !== file.uid)
                        );
                      }
                      return fileList;
                    }}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value) {
                            if (
                              value
                                .map((item) => item.status)
                                .includes('uploading')
                            ) {
                              return Promise.reject(new Error('上傳中'));
                            }
                            if (
                              value.map((item) => item.status).includes('error')
                            ) {
                              return Promise.reject(
                                new Error('上傳失敗，請重新上傳或者移除檔案')
                              );
                            }
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Upload
                      {...field.input.props}
                      fileList={form.getFieldValue(field.name)}
                      customRequest={async (options) => {
                        const { onSuccess, onError, file } = options;
                        if (file.size > 1024 * 1024 * 20) {
                          onError({ message: '上傳檔案不能超過20MB' });
                          return;
                        }
                        try {
                          const res = await uploadFiles(dbName, options.file);
                          onSuccess(res.data);
                        } catch (err) {
                          onError(err, null);
                          console.error({ err });
                        }
                      }}
                      onRemove={async (file) => {
                        try {
                          await deleteFile(file);
                        } catch (err) {
                          console.error({ err });
                        }
                      }}
                    >
                      <Button>上傳</Button>
                    </Upload>
                  </Item>
                );
                return <Fragment key={index}>{fieldComponent}</Fragment>;
              } else {
                // if (field.item.props.name !== 'service') {
                if (
                  field.item.props.name !== 'contractPeriod' &&
                  field.item.props.name !== 'service'
                ) {
                  const InputComponent = inputs[field.input.type];
                  // console.log(InputComponent);
                  // console.log(formatValue[field.name]);
                  fieldComponent = (
                    <Item {...field.item.props}>
                      <span>{formatValue[field.name]}</span>
                      {/* <InputComponent {...field.input.props} /> */}
                    </Item>
                  );

                  return <Fragment key={index}>{fieldComponent}</Fragment>;
                } else {
                  if (field.item.props.name === 'contractPeriod') {
                    fieldComponent = (
                      <Item {...field.item.props}>
                        <span>
                          {moment(formatValue[field.name][0]).format(
                            'YYYY/MM/DD'
                          )}
                          ~
                          {moment(formatValue[field.name][1]).format(
                            'YYYY/MM/DD'
                          )}
                        </span>
                        {/* <InputComponent {...field.input.props} /> */}
                      </Item>
                    );
                  } else {
                    fieldComponent = (
                      <Item {...field.item.props}>
                        <span>報修服務</span>
                      </Item>
                    );
                  }
                  return <Fragment key={index}>{fieldComponent}</Fragment>;
                }
              }
            })}
        </Form>
        <Box
          sx={{
            borderRadius: '5px',
            backgroundColor: '#fff',
            marginTop: '10px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            // alignItems: 'end',
            gap: '20px',
          }}
        >
          <h2>設備資產</h2>
          <Table dataSource={deviceList}>
            <Table.Column title="設備名稱" dataIndex="deviceName" />
            <Table.Column title="保管人" dataIndex="deviceKeeper" />
            <Table.Column
              title="購入日期"
              dataIndex="deviceDate"
              cell={(text) => {
                return <span>{moment(text).format('YYYY/MM/DD')}</span>;
              }}
            />
            <Table.Column title="設備狀態" dataIndex="status" />
            <Table.Column
              title="操作"
              cell={(text, _, record) => {
                return (
                  <Button
                    type="secondary"
                    onClick={() => {
                      console.log(record, '===record');
                      setDeviceDetail(record);
                      setShowDeviceDetail(true);
                    }}
                  >
                    查看
                  </Button>
                );
              }}
            />
          </Table>
          <Pagination
            total={deviceList.length}
            current={currentPage}
            onChange={(page) => {
              setCurrentPage(page);
            }}
            style={{ alignSelf: 'end', marginTop: '10px' }}
          />
        </Box>
        <Box
          sx={{
            borderRadius: '5px',
            backgroundColor: '#fff',
            marginTop: '10px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            // alignItems: 'end',
            gap: '20px',
          }}
        >
          <h2>績效評分列表</h2>
          <Table dataSource={questionnaireList}>
            <Table.Column title="評分項目" dataIndex="service" />
            <Table.Column
              title="上個月管委會分數"
              dataIndex="committeeScore"
              cell={(text) => {
                return <span>{text ? text : '未評分'}/5</span>;
              }}
            />
            <Table.Column
              title="上個月住戶平均分數"
              dataIndex="residentScore"
              cell={(text) => {
                return <span>{text ? text : '未評分'}/5</span>;
              }}
            />
            <Table.Column
              title="上個月加權分數"
              dataIndex="totalScore"
              cell={(text) => {
                return <span>{text ? text : '未評分'}/5</span>;
              }}
            />
            <Table.Column
              title="滿意度"
              dataIndex="satisfaction"
              cell={(text) => {
                return <span>{text ? text : '未評分'}%</span>;
              }}
            />
            <Table.Column
              title="等級"
              dataIndex="rank"
              cell={(text) => {
                return <span>{text ? text : '未評分'}</span>;
              }}
            />
          </Table>
        </Box>
      </Dialog>

      {/* 資產查看 */}
      <Dialog
        visible={showDeviceDetail}
        onClose={() => setShowDeviceDetail(false)}
        onOk={() => setShowDeviceDetail(false)}
        okProps={{ children: '關閉' }}
        cancelProps={{ style: { display: 'none' } }}
        title="設備資料"
      >
        <RecordDescription record={deviceDetail} />
      </Dialog>
    </>
  );
}

export default React.memo(ViewButton);
